<template>
    <v-card>
        <v-card-title>
            Log In
        </v-card-title>
        <v-card-text>
            <p>
                You need to log in!
            </p>
            <p class="mt-8">
                <v-btn v-if="!isLoggedIn" large min-width="280" :href="getAdminLoginUrl">Log In via Django Admin</v-btn>
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data: () => ({
            baseUrl: '/',
        }),
        computed: {
            getAdminLoginUrl: function() {
                return this.baseUrl + 'admin/login/?next=/';
            },
            ...mapGetters([
                'currentUser',
                'isLoggedIn',
            ])
        }
    }
</script>